/**
 * Builds the `nav_item_path` analytics parameter from the labels on the way to the clicked item:
 * `['Men', 'Shoes & Accessories', 'Footwear']` → `men/shoes_accessories/footwear`.
 * Localized letters and digits are kept, since labels are tracked in the site language.
 */
export const getNavItemPath = (labels: string[]): string =>
  labels
    .map(label =>
      label
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, '_')
        .replace(/^_+|_+$/g, '')
    )
    .filter(Boolean)
    .join('/');
